import React from "react"; //para poder usar codigo JSX

export default function Admin() {
  return (
    <div>
      <h1>Estamos en la página Admin</h1>
    </div>
  );
}
